import styled from '@emotion/styled';
import { Text } from '@lbcamden/lib-react';
import { AnchorHTMLAttributes, Ref } from 'react';

export const MarkdownText = styled(Text)`
  strong {
    font-weight: 600;
  }

  em {
    font-style: normal;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

const BaseMarkdownLink = ({
  ref,
  children,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & { ref?: Ref<HTMLAnchorElement> }) => (
  <a ref={ref} {...props} target="_blank" rel="noreferrer">
    {children}
  </a>
);

export const MarkdownLink = styled(BaseMarkdownLink)`
  display: inline-flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;

  svg {
    flex-shrink: 0;
  }
`;
